'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * 뒤로가기로 되살아난 화면을 **서버에 다시 물어본다**(2026-09-02 사용자 제보).
 *
 * 로그아웃한 뒤 뒤로가기를 누르면 **로그인 상태로 보이는 일이 간헐적으로** 있었다.
 * 브라우저가 문서를 통째로 되살리는 bfcache 때문이다 — 서버에 다시 묻지 않으므로
 * 셸이 로그인했을 때 그린 그대로(회원명·로그아웃 버튼·마이 메뉴) 남는다.
 * 쿠키는 이미 지워졌으니 **화면만 거짓말을 하는** 상태다.
 *
 * `pageshow(persisted)` 는 그 되살림에서만 온다 — 평범한 뒤로가기는 Next 가 클라이언트
 * 라우팅으로 처리하고 동적 화면은 어차피 서버에 다시 묻는다(결제 완료 가드에서 겪은 그 차이).
 * 그래서 **되살아났을 때만** 새로 고치고, 그 밖에는 아무 일도 하지 않는다.
 *
 * `router.refresh()` 는 지금 주소를 그대로 두고 **서버 렌더만 다시 받는다** — 셸이 비로그인으로
 * 바뀌고, 로그인이 필요한 화면이면 서버가 로그인 화면으로 보낸다(`requireMe`).
 */
export function SessionSync() {
  const router = useRouter();

  useEffect(() => {
    const onShow = (e: PageTransitionEvent) => { if (e.persisted) router.refresh(); };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, [router]);

  return null;
}
